import { render, staticRenderFns } from "./protocolConfigList.vue?vue&type=template&id=30596250&scoped=true"
import script from "./protocolConfigList.vue?vue&type=script&lang=js"
export * from "./protocolConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30596250",
  null
  
)

export default component.exports